(function() {
    'use strict';

    angular.module('remitEventsApp').controller('HeaderController', function($cookies, $rootScope, $translate, moment, tmhDynamicLocale) {
        var vm = this;

        function checkActiveLanguage(language) {
            return language === $translate.use();
        }

        vm.changeLanguage = function(language) {
            if (!checkActiveLanguage(language)) {
                $translate.use(language).then(function() {
                    $translate.refresh().then(function() {
                        $rootScope.$broadcast('languageChange', language);
                    });
                });

                moment.locale(language);
                tmhDynamicLocale.set(language);
                $cookies.putObject('remit-lang', language);
            }
        };
    });
})();
